import { defineMessages } from '@jutro/locale';

export default defineMessages({
    viewSchedule: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.View Schedule',
        defaultMessage: 'View Schedule'
    },
    yes: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.Yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.No',
        defaultMessage: 'No'
    },
    updatePaymentOptions: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.UPDATE PAYMENT OPTIONS',
        defaultMessage: 'UPDATE PAYMENT OPTIONS'
    },
    dateAndAmount: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.Date - Amount',
        defaultMessage: '{date} - {amount}'
    },
    scheduleAndDays: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.schedule - days',
        defaultMessage: '{schedule} - {days}'
    },
    day1AndDay2: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.day1 and day2',
        defaultMessage: '{day1} and {day2}'
    },
    checkingOrSavings: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.Checking or Savings',
        defaultMessage: 'Checking or Savings'
    },
    endingInNumber: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.Ending in number',
        defaultMessage: 'Ending in {number}'
    },
    payrollDeduct: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.Payroll Deduct',
        defaultMessage: 'Payroll Deduct'
    },
    payOnlineOrByMail: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.Pay Online or By Mail',
        defaultMessage: 'Pay Online or By Mail'
    },
    mortgageeBill: {
        id: 'ml.gateway.MLAgentPolicyBillingPaymentDetailsComponent.Mortgagee bill',
        defaultMessage: 'Mortgagee bill'
    }
    
});